import { useEffect } from "react";

import AutoCompleteInit from "../../../helpers/AutoCompleteInit";
import { SpDateChoosersInit } from "../../../helpers/DateChoosersInit";
import CONSTANTS from "../../../Constants/Constants";

import { show_search_page } from "../../../helpers/PageRoutingFuncs";
import Type1SearchForm from "../SearchFormTypes/Type1SearchForm";
import Type4SearchForm from "../SearchFormTypes/Type4SearchForm";

function SearchForm( props ){

    const {
        showSearchPageForm,
        bookingEngine,
        agentDetails,
    } = props;

    useEffect(()=>{
        let flight_search_data = JSON.parse(localStorage.getItem("search_obj"));
        if(bookingEngine.searchResultPageFormType){
            SpDateChoosersInit(
                flight_search_data.type.toUpperCase(),
                flight_search_data.itinerary.departure.date,
                flight_search_data.itinerary.arrival.date
            );
            AutoCompleteInit();
            const trip_round = flight_search_data.type;
            sp_select_trip_round(
                trip_round,
                flight_search_data.itinerary.departure.date,
                flight_search_data.itinerary.arrival.date
            );
            const cb_class = flight_search_data.itinerary.cabin.toLowerCase();
            sp_select_cabin_type(cb_class);
            const travelers={};
            travelers.adults=flight_search_data.itinerary.travelers.adults;
            travelers.children=flight_search_data.itinerary.travelers.children;
            travelers.infants=flight_search_data.itinerary.travelers.infants;
            sp_set_default_travelers(travelers);
        }
        
    }, [ bookingEngine ]);

    const isAllSearchInputsSet = () => {
        if(document.getElementById("sp_search_forms_from_where_input_fld").value===""){
            document.getElementById("sp_search_forms_from_where_input_fld").click();
            return false;
        }else if(document.getElementById("sp_search_forms_to_where_input_fld").value===""){
            document.getElementById("sp_search_forms_to_where_input_fld").click();
            return false;
        }else if(document.getElementById("sp_departure_return_dates_input").value===""){
            document.getElementById("sp_departure_return_dates_input").click();
            return false;
        }

        return true;
    }

    const searchOnSubmit = () => {
        if(!isAllSearchInputsSet())
            return;
        window.location.href="/search";
        setTimeout(()=>{
            show_search_page(); 
            props.submitFromSearchPage();
        }, 100);
        
    }

    let _is_bl_search = false;
    if(localStorage.getItem("booking_link")){
        _is_bl_search = true;
    }

    let show_search_form = false;
    const params = new URLSearchParams(window.location.search);
    if(params.has("show_search_form")){
        show_search_form = JSON.parse(params.get('show_search_form').trim());
    }

    const formType = parseInt(bookingEngine.searchResultPageFormType);

    return(
        <div id="search_results_page_search_form" className="main-search-form" style={{display: showSearchPageForm ? "block" : "none", position: "relative"}}>
            {
                (_is_bl_search && !show_search_form) && <div style={{position: "absolute", left: 0, right: 0, zIndex: 100, height: "100%", width: "100%", backgroundColor: "rgba(255,255,255,0.5)"}}>
                    <div style={{backgroundColor: "crimson", padding: 10, position: "absolute", width: "100%", bottom: 0, left: 0}}>
                        <p style={{color: "white", fontSize: 13}}>
                            <i style={{marginRight: 10, color: "yellow"}}
                                className="fa-solid fa-info-circle"></i>
                            You are searching from an agent created link...</p>
                        <div style={{display: "flex", marginTop: 5, marginLeft: 20}}>
                            <p onClick={()=>window.location.reload()}
                                style={{cursor: "pointer", color: "skyblue", fontSize: 14, textDecoration: "underline"}}>
                                Reload Page</p>
                            <p style={{margin: "0 10px", color: "rgba(255,255,255,0.4)"}}>
                                /</p>
                            <p onClick={()=>{
                                    localStorage.removeItem("booking_link");
                                    window.location.href = "/search";
                                }} 
                                style={{cursor: "pointer", color: "lightgreen", fontSize: 14, textDecoration: "underline"}}>
                                Reset page</p>
                        </div>
                    </div>
                </div>
            }
            {
                formType===1 &&
                <Type1SearchForm
                    searchOnSubmit={searchOnSubmit}
                    agentDetails={agentDetails}
                    bookingEngine={bookingEngine}
                    sp_remove_traveler={sp_remove_traveler}
                    sp_add_traveler={sp_add_traveler}
                    sp_select_cabin_type={sp_select_cabin_type}
                    sp_select_trip_round={sp_select_trip_round}
                    sp_show_cabin_settings_pane={sp_show_cabin_settings_pane}
                    sp_show_travelers_settings_pane={sp_show_travelers_settings_pane}
                    sp_show_trip_round_settings_pane={sp_show_trip_round_settings_pane}
                    sp_open_from_where_auto_complete_pane={sp_open_from_where_auto_complete_pane}
                    sp_switch_airports_input_values={sp_switch_airports_input_values}
                    sp_open_to_where_auto_complete_pane={sp_open_to_where_auto_complete_pane}
                />
            }
            {
                formType===4 &&
                <Type4SearchForm
                    searchOnSubmit={searchOnSubmit}
                    agentDetails={agentDetails}
                    bookingEngine={bookingEngine}
                    sp_remove_traveler={sp_remove_traveler}
                    sp_add_traveler={sp_add_traveler}
                    sp_select_cabin_type={sp_select_cabin_type}
                    sp_select_trip_round={sp_select_trip_round}
                    sp_show_cabin_settings_pane={sp_show_cabin_settings_pane}
                    sp_show_travelers_settings_pane={sp_show_travelers_settings_pane}
                    sp_show_trip_round_settings_pane={sp_show_trip_round_settings_pane}
                    sp_open_from_where_auto_complete_pane={sp_open_from_where_auto_complete_pane}
                    sp_switch_airports_input_values={sp_switch_airports_input_values}
                    sp_open_to_where_auto_complete_pane={sp_open_to_where_auto_complete_pane}
                />
            }
        </div>
    );
}

let sp_switch_btn_switched = false
function sp_switch_input_rotate_func(){

    let INITIAL_ROTATE=0;
    let FINAL_ROTATE=360;
    if(global.$(window).width()<=CONSTANTS.viewport_threshold){
        INITIAL_ROTATE=90;
        FINAL_ROTATE=270;
    }
    
    if(!sp_switch_btn_switched){
        if(document.getElementById("sp_main_switch_inputs_btn"))
            document.getElementById("sp_main_switch_inputs_btn").style.transform = "rotate("+FINAL_ROTATE+"deg)";
        sp_switch_btn_switched = true;
    }else{
        if(document.getElementById("sp_main_switch_inputs_btn"))
            document.getElementById("sp_main_switch_inputs_btn").style.transform = "rotate("+INITIAL_ROTATE+"deg)";
        sp_switch_btn_switched = false;
    }
    
}

function sp_switch_airports_input_values(){
    let from_airport_value = document.getElementById("sp_search_forms_from_where_input_fld").value;
    document.getElementById("sp_search_forms_from_where_input_fld").value = document.getElementById("sp_search_forms_to_where_input_fld").value;
    document.getElementById("sp_search_forms_to_where_input_fld").value = from_airport_value;
    sp_switch_input_rotate_func();

    let flight_search_data = JSON.parse(localStorage.getItem("search_obj"));
    let temp_iata = flight_search_data.itinerary.departure.airport;
    flight_search_data.itinerary.departure.airport = flight_search_data.itinerary.arrival.airport;
    flight_search_data.itinerary.arrival.airport = temp_iata;
    window.localStorage.setItem("search_obj", JSON.stringify(flight_search_data));

}

function sp_open_to_where_auto_complete_pane(){
    document.getElementById("sp_to_where_airports_auto_complete_input").style.display = "block";
    document.getElementById("sp_to_where_airports_auto_complete_input_fld").focus();
}
function sp_open_from_where_auto_complete_pane(){
    document.getElementById("sp_from_where_airports_auto_complete_input").style.display = "block"
    document.getElementById("sp_from_where_airports_auto_complete_input_fld").focus();
}
function sp_show_trip_round_settings_pane(){
    document.getElementById("sp_select_trip_round_settings_pane").style.display = "block";
    document.getElementById("sp_forms_main_class_guests_cabin_settings_pane").style.display = "block";

    document.getElementById("sp_select_cabin_settings_pane").style.display = "none";
    document.getElementById("sp_add_travelers_settings_pane").style.display = "none";
}
function sp_show_cabin_settings_pane(){
    document.getElementById("sp_select_cabin_settings_pane").style.display = "block";
    document.getElementById("sp_forms_main_class_guests_cabin_settings_pane").style.display = "block";

    document.getElementById("sp_select_trip_round_settings_pane").style.display = "none";
    document.getElementById("sp_add_travelers_settings_pane").style.display = "none";
}
function sp_show_travelers_settings_pane(){
    document.getElementById("sp_add_travelers_settings_pane").style.display = "block";
    document.getElementById("sp_forms_main_class_guests_cabin_settings_pane").style.display = "block";

    document.getElementById("sp_select_trip_round_settings_pane").style.display = "none";
    document.getElementById("sp_select_cabin_settings_pane").style.display = "none";
}

//-------------------------------
function sp_select_cabin_type(type="economy"){
    let flight_search_data = JSON.parse(localStorage.getItem("search_obj"));

    Array.from(document.getElementsByClassName("sp_select_cabin_type_chk")).forEach( each=> {
        each.checked = false;
    });
    if(type === "cheapest"){
        document.getElementById("sp_select_cabin_cheapest_chk").checked = true;
        document.getElementById("sp_select_cabin_type_main_input_display").innerHTML = `
            <i style="fontSize: 15px; margin-right: 10px" class="fa fa-level-up"></i>
            Cheapest
            <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
        `;
        flight_search_data.itinerary.cabin = "LCC";
    }else if(type === "economy"){
        document.getElementById("sp_select_cabin_economy_chk").checked = true;
        document.getElementById("sp_select_cabin_type_main_input_display").innerHTML = `
            <i style="fontSize: 15px; margin-right: 10px" class="fa fa-level-up"></i>
            Economy
            <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
        `;
        flight_search_data.itinerary.cabin = "ECONOMY";
    }else if(type === "premium"){
        document.getElementById("sp_select_cabin_premium_chk").checked = true;
        document.getElementById("sp_select_cabin_type_main_input_display").innerHTML = `
            <i style="fontSize: 15px; margin-right: 10px" class="fa fa-level-up"></i>
            Premium
            <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
        `;
        flight_search_data.itinerary.cabin = "PREMIUM";
    }else if(type === "business"){
        document.getElementById("sp_select_cabin_business_chk").checked = true;
        document.getElementById("sp_select_cabin_type_main_input_display").innerHTML = `
            <i style="font-size: 15px; margin-right: 10px" class="fa fa-level-up"></i>
            Business
            <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
        `;
        flight_search_data.itinerary.cabin = "BUSINESS";
    }else if(type === "first"){
        document.getElementById("sp_select_cabin_first_chk").checked = true;
        document.getElementById("sp_select_cabin_type_main_input_display").innerHTML = `
            <i style="fontSize: 15px; margin-right: 10px" class="fa fa-level-up"></i>
            First
            <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
        `;
        flight_search_data.itinerary.cabin = "FIRST";
    }
    if(window.__setCabinClass){
        window.__setCabinClass((type.substring(0,1).toUpperCase()+type.substring(1)));
    }
    window.localStorage.setItem("search_obj", JSON.stringify(flight_search_data));
}

function sp_select_trip_round(type="one-way", start_date="", end_date=""){
    let flight_search_data = JSON.parse(localStorage.getItem("search_obj"));

    Array.from(document.getElementsByClassName("sp_select_trip_round_chk")).forEach( each=> {
        each.checked = false;
    });
    if(type === "round-trip"){
        document.getElementById("sp_trip_round_round_trip_chk").checked = true;
        document.getElementById("sp_select_trip_round_main_input_display").innerHTML = `
            <i style="fontSize: 15px; margin-right: 10px" class="fa fa-repeat"></i>
            Round-trip
            <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
        `;
        flight_search_data.type = "round-trip";
        SpDateChoosersInit(CONSTANTS.round_trip, start_date, end_date);
        if(document.getElementById("sp_departure_return_dates_input"))
            document.getElementById("sp_departure_return_dates_input").placeholder="departure - return";
    }else if(type === "one-way"){
        document.getElementById("sp_trip_round_one_way_chk").checked = true;
        document.getElementById("sp_select_trip_round_main_input_display").innerHTML = `
            <i style="font-size: 15px; margin-right: 10px" class="fa fa-repeat"></i>
            One-way
            <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
        `;
        flight_search_data.type = "one-way";
        SpDateChoosersInit(CONSTANTS.one_way, start_date, end_date);
        if(document.getElementById("sp_departure_return_dates_input"))
            document.getElementById("sp_departure_return_dates_input").placeholder="departure";
    }else if(type === "multi-city"){
        document.getElementById("sp_trip_round_multi_city_chk").checked = true;
        document.getElementById("sp_select_trip_round_main_input_display").innerHTML = `
            <i style="fontSize: 15px; margin-right: 10px" class="fa fa-repeat"></i>
            Multi-city
            <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
        `;
        flight_search_data.type = "multi-city";
    }
    if(window.__setTripType){
        if(type==="one-way"){
            window.__setTripType("oneway");
        }else if(type==="round-trip"){
            window.__setTripType("round");
        }
    }
    window.localStorage.setItem("search_obj", JSON.stringify(flight_search_data));
}

let travelers = {
    adults: 0,
    children: 0,
    infants: 0,
}
function sp_add_traveler(type="adult"){
    
    if((travelers.adults + travelers.children + travelers.infants) > 14){
        alert("only maximum of 15 travelers allowed")
        return;
    }

    if(type === "adult"){
        travelers.adults += 1;

        if(travelers.adults > 1 && travelers.infants == 0 && travelers.children == 0){
            document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                ${travelers.adults} Adults
                <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>`;
        }else{
            (travelers.adults + travelers.children + travelers.infants) > 1 ?
                document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers.adults + travelers.children + travelers.infants} Travelers
                ` : document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                        <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                        ${travelers.adults} Adult
                        <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
                    `
        }

        document.getElementById("sp_add_travelers_display_adults_number").innerHTML = travelers.adults;
    }else if(type === "child"){
        travelers.children += 1;

        if(travelers.children > 1 && travelers.infants == 0 && travelers.adults == 0){
            document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                ${travelers.children} Children
                <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>`;
        }else{
            (travelers.adults + travelers.children + travelers.infants) > 1 ?
                document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers.adults + travelers.children + travelers.infants} Travelers
                `: document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                        <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                        ${travelers.children} Child
                        <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
                    `
        }
            document.getElementById("sp_add_travelers_display_children_number").innerHTML = travelers.children;
    }else if(type === "infant"){
        travelers.infants += 1;

        if(travelers.infants > 1 && travelers.children == 0 && travelers.adults == 0){
            document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                ${travelers.infants} Infants
                <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>`;
        }else{
            (travelers.adults + travelers.children + travelers.infants) > 1 ?
                document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers.adults + travelers.children + travelers.infants} Travelers
                `: document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers.infants} Infant
                    <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
            `
        }
        
        document.getElementById("sp_add_travelers_display_infants_number").innerHTML = travelers.infants;
    }

    if(window.__setTravelers)
        window.__setTravelers((travelers.adults+travelers.children+travelers.infants));

    //adding current travelers setting to local storage
    let flight_search_data = JSON.parse(localStorage.getItem("search_obj"));
    flight_search_data.itinerary.travelers.adults = travelers.adults;
    flight_search_data.itinerary.travelers.children = travelers.children;
    flight_search_data.itinerary.travelers.infants = travelers.infants;
    window.localStorage.setItem("search_obj", JSON.stringify(flight_search_data));
}

function sp_remove_traveler(type="adult"){

    if((travelers.adults + travelers.children + travelers.infants) < 2){
        alert("at least one(1) adult or child traveler required")
        return;
    }

    if(type === "adult"){
        if((travelers.adults-1)<0){
            return;
        }
        travelers.adults -= 1;
        if(travelers.adults > 1 && travelers.infants == 0 && travelers.children == 0){
            document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                ${travelers.adults} Adults
                <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>`;
        }else if(travelers.adults < 1 && travelers.infants > 0 && travelers.children == 0){
            if(travelers.infants > 1 && travelers.children == 0 && travelers.adults == 0){
                document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers.infants} Infants`;
            }else{
                (travelers.adults + travelers.children + travelers.infants) > 1 ?
                    document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                        <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                        ${travelers.adults + travelers.children + travelers.infants} Travelers
                    `: document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                        <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                        ${travelers.infants} Infant
                        <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
                `
            }
        }else if(travelers.adults < 1 && travelers.infants == 0 && travelers.children > 0){
            if(travelers.children > 1 && travelers.infants == 0 && travelers.adults == 0){
                document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers.children} Children
                    <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>`;
            }else{
                (travelers.adults + travelers.children + travelers.infants) > 1 ?
                    document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                        <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                        ${travelers.adults + travelers.children + travelers.infants} Travelers
                    `: document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                            <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                            ${travelers.children} Child
                            <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
                        `
            }
        }else{
            (travelers.adults + travelers.children + travelers.infants) > 1 ?
                document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers.adults + travelers.children + travelers.infants} Travelers
                    <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
                ` : document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                        <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                        ${travelers.adults} Adult
                        <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
                    `
        }

        document.getElementById("sp_add_travelers_display_adults_number").innerHTML = travelers.adults;
    }else if(type === "child"){
        if((travelers.children-1)<0){
            return;
        }
        travelers.children -= 1;
        if(travelers.children > 1 && travelers.infants == 0 && travelers.adults == 0){
            document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                ${travelers.children} Children
                <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>`;
        }else if(travelers.adults == 0 && travelers.infants > 0 && travelers.children < 1){
            if(travelers.infants > 1 && travelers.children == 0 && travelers.adults == 0){
                document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers.infants} Infants
                    <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>`;
            }else{
                (travelers.adults + travelers.children + travelers.infants) > 1 ?
                    document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                        <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                        ${travelers.adults + travelers.children + travelers.infants} Travelers
                        <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
                    `: document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                        <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                        ${travelers.infants} Infant
                        <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
                `
            }
        }else if(travelers.adults > 0 && travelers.infants == 0 && travelers.children < 1){
            if(travelers.adults > 1 && travelers.infants == 0 && travelers.children == 0){
                document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers.adults} Adults
                    <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>`;
            }else{
                (travelers.adults + travelers.children + travelers.infants) > 1 ?
                    document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                        <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                        ${travelers.adults + travelers.children + travelers.infants} Travelers
                        <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
                    ` : document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                            <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                            ${travelers.adults} Adult
                            <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
                        `
            }
        }else{
            (travelers.adults + travelers.children + travelers.infants) > 1 ?
                document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers.adults + travelers.children + travelers.infants} Travelers
                `: document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                        <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                        ${travelers.children} Child
                        <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
                    `
        }

        document.getElementById("sp_add_travelers_display_children_number").innerHTML = travelers.children;
    }else if(type === "infant"){
        if((travelers.infants-1)<0){
            return;
        }
        travelers.infants -= 1;
        if(travelers.infants > 1 && travelers.children == 0 && travelers.adults == 0){
            document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                ${travelers.infants} Infants
                <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>`;
        }else if(travelers.adults == 0 && travelers.infants < 1 && travelers.children > 0){
            if(travelers.infants > 1 && travelers.children == 0 && travelers.adults == 0){
                document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers.infants} Infants
                    <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>`;
            }else{
                (travelers.adults + travelers.children + travelers.infants) > 1 ?
                    document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                        <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                        ${travelers.adults + travelers.children + travelers.infants} Travelers
                    `: document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                        <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                        ${travelers.infants} Infant
                        <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
                `
            }
        }else if(travelers.adults > 0 && travelers.infants < 1 && travelers.children == 0){
            if(travelers.adults > 1 && travelers.infants == 0 && travelers.children == 0){
                document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers.adults} Adults
                    <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>`;
            }else{
                (travelers.adults + travelers.children + travelers.infants) > 1 ?
                    document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                        <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                        ${travelers.adults + travelers.children + travelers.infants} Travelers
                    ` : document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                            <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                            ${travelers.adults} Adult
                            <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
                        `
            }
        }else{
            (travelers.adults + travelers.children + travelers.infants) > 1 ?
                document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers.adults + travelers.children + travelers.infants} Travelers
                    <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
                `: document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers.infants} Infant
                    <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
            `
        }
        
        document.getElementById("sp_add_travelers_display_infants_number").innerHTML = travelers.infants;
    }

    if(window.__setTravelers)
        window.__setTravelers((travelers.adults+travelers.children+travelers.infants));
    
    //adding current travelers setting to local storage
    let flight_search_data = JSON.parse(localStorage.getItem("search_obj"));
    flight_search_data.itinerary.travelers.adults = travelers.adults;
    flight_search_data.itinerary.travelers.children = travelers.children;
    flight_search_data.itinerary.travelers.infants = travelers.infants;
    window.localStorage.setItem("search_obj", JSON.stringify(flight_search_data));
}

function sp_set_default_travelers(travelers_p){

    document.getElementById("sp_add_travelers_display_adults_number").innerHTML="0";
    document.getElementById("sp_add_travelers_display_children_number").innerHTML="0";
    document.getElementById("sp_add_travelers_display_infants_number").innerHTML="0";

    travelers=travelers_p;

    if((travelers_p.adults + travelers_p.children + travelers_p.infants) > 14){
        alert("only maximum of 15 travelers allowed")
        return;
    }

    if(travelers_p?.adults>0){
        if(travelers_p.adults > 1 && travelers_p.infants === 0 && travelers_p.children === 0){
            document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                ${travelers_p.adults} Adults
                <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>`;
        }else{
            (travelers_p.adults + travelers_p.children + travelers_p.infants) > 1 ?
                document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers_p.adults + travelers_p.children + travelers_p.infants} Travelers
                ` : document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                        <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                        ${travelers_p.adults} Adult
                        <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
                    `
        }

        document.getElementById("sp_add_travelers_display_adults_number").innerHTML = travelers_p.adults;
    }
    if(travelers_p?.children>0){
        if(travelers_p.children > 1 && travelers_p.infants === 0 && travelers_p.adults === 0){
            document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                ${travelers_p.children} Children
                <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>`;
        }else{
            (travelers_p.adults + travelers_p.children + travelers_p.infants) > 1 ?
                document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers_p.adults + travelers_p.children + travelers_p.infants} Travelers
                `: document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                        <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                        ${travelers_p.children} Child
                        <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
                    `
        }
        document.getElementById("sp_add_travelers_display_children_number").innerHTML = travelers_p.children;
    }
    if(travelers_p?.infants>0){
        if(travelers_p.infants > 1 && travelers_p.children === 0 && travelers_p.adults === 0){
            document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                ${travelers_p.infants} Infants
                <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>`;
        }else{
            (travelers_p.adults + travelers_p.children + travelers_p.infants) > 1 ?
                document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers_p.adults + travelers_p.children + travelers_p.infants} Travelers
                `: document.getElementById("sp_add_travelers_main_input_display").innerHTML = `
                    <i style="fontSize: 15px; margin-right: 10px" class="fa fa-user"></i>
                    ${travelers_p.infants} Infant
                    <i style={{marginLeft: 10, color: "rgb(43, 52, 61)"}} className="fa fa-angle-down"></i>
            `
        }
        
        document.getElementById("sp_add_travelers_display_infants_number").innerHTML = travelers_p.infants;
    }

    if(window.__setTravelers)
        window.__setTravelers((travelers_p.adults+travelers_p.children+travelers_p.infants));
    //adding current travelers setting to local storage
    let flight_search_data = JSON.parse(localStorage.getItem("search_obj"));
    flight_search_data.itinerary.travelers.adults = travelers_p.adults;
    flight_search_data.itinerary.travelers.children = travelers_p.children;
    flight_search_data.itinerary.travelers.infants = travelers_p.infants;
    window.localStorage.setItem("search_obj", JSON.stringify(flight_search_data));
}

export default SearchForm;